"use strict";

define('components/document_tree',['components/ajax'], function(ajax) {

    var documentTreeCmp = {
        init: function(modalNode) {
            if (typeof(modalNode) === 'undefined') {
                modalNode = $(document);
            }

            var docTreeNode = modalNode.find('.document-tree');

            // Document tree navigation behavior
            documentTreeCmp.initializeNavigation(docTreeNode);

            // Document sorting
            documentTreeCmp.initializeSorting(docTreeNode);

            // No additional behavior if not in picker mode
            if (!docTreeNode.is('.document-picker')) {
                return;
            }

            // Initialize the category selected and documents selections
            documentTreeCmp._updateCategorySelectedCounts(docTreeNode);
            documentTreeCmp.initializeDocumentSelections(docTreeNode);

            // Select all/none/reverse buttons
            if (documentTreeCmp.canSelectMultiple(docTreeNode)) {
                documentTreeCmp.initializeBulkSelect(docTreeNode);
            } else {
                // If we cannot select multiple docs, hide the all/none/reverse buttons
                // and change checkboxes to radioboxes.
                docTreeNode.find('thead .cell-checkbox .btn-group').hide();
                docTreeNode.find('input[name="doc_id"]').attr('type', 'radio');
            }

            // Individual document selection behavior
            documentTreeCmp.initializeDocSelect(docTreeNode);
        },

        canSelectMultiple: function(docTreeNode) {
            return !docTreeNode.closest('[data-select-multiple="no"]')[0];
        },

        initializeNavigation: function(docTreeNode) {
            // Navigate to document list on category click
            var categoryList = docTreeNode.find('div.categories');
            categoryList.on('click', 'tr', function(e) {
                e.preventDefault();
                e.stopPropagation();
                var categoryId = $(this).data('category-id');
                docTreeNode.find('#document-list-' + categoryId).removeClass('hidden');
                categoryList.addClass('hidden');
            });

            // Navigate back to category list from document list
            docTreeNode.find('.back-to-categories').click(function(e) {
                e.preventDefault();
                e.stopPropagation();
                docTreeNode.find('.document-list').addClass('hidden');
                categoryList.removeClass('hidden');
            });
        },

        initializeSorting: function(docTreeNode) {
            // Sort buttons on document table
            docTreeNode.on('click', '.document-list thead td.sortable', function(e) {
                e.preventDefault();

                var icon = $(this).find('.glyphicon');
                if (icon.is('.glyphicon-arrow-down')) {
                    icon.removeClass('glyphicon-arrow-down');
                    icon.addClass('glyphicon-arrow-up');
                } else {
                    icon.removeClass('glyphicon-arrow-up');
                    icon.removeClass('glyphicon-sort');
                    icon.addClass('glyphicon-arrow-down');
                }

                var sortKey = $(this).data('sort-key');
                var sortDir = icon.is('.glyphicon-arrow-down') ? 1 : -1;
                var tableBody = $(this).closest('table').find('tbody');
                var dataRows = tableBody.find('tr');
                dataRows.sort(function(lhs, rhs) {
                    var lhsVal = $(lhs).data('sort-'+sortKey);
                    var rhsVal = $(rhs).data('sort-'+sortKey);
                    if (lhsVal < rhsVal) {
                        return sortDir * -1;
                    } else if (lhsVal > rhsVal) {
                        return sortDir;
                    }
                    return ($(lhs).data('id') < $(rhs).data('id')) ? sortDir * -1 : 1;
                });
                dataRows.each(function(idx, row) {
                    tableBody.append(row);
                });


                // Set all other columns to unsorted
                $(this).siblings('.sortable').each(function(){
                    $(this).find('.glyphicon')
                           .removeClass('glyphicon-arrow-up')
                           .removeClass('glyphicon-arrow-down')
                           .addClass('glyphicon-sort');
                });
            });
        },

        initializeBulkSelect: function(docTreeNode) {
            // Select all/none/reverse buttons
            docTreeNode.on('click', '.document-list ul.dropdown-menu a.select', function(e) {
                e.preventDefault();
                var table = $(this).closest('table');
                if ($(this).is('.select-all')) {
                    table.find('tr input[name="doc_id"]').each(function() {
                        var input = $(this);
                        documentTreeCmp.selectDocumentId(docTreeNode, input.val(), input);
                     });
                } else if ($(this).is('.select-none')) {
                    table.find('tr input[name="doc_id"]').each(function() {
                        var input = $(this);
                        documentTreeCmp.deselectDocumentId(docTreeNode, input.val(), input);
                     });
                } else if ($(this).is('.select-reverse')) {
                    table.find('tr input[name="doc_id"]').each(function() {
                        var input = $(this);
                        documentTreeCmp.toggleDocumentId(docTreeNode, input.val(), input);
                    });
                }
            });
        },

        initializeDocSelect: function(docTreeNode) {
            if (documentTreeCmp.canSelectMultiple(docTreeNode)) {
                // Make the table row reflect the state of the checkbox
                docTreeNode.on('click', 'tr[data-id]:not(.disabled) input[name="doc_id"]', function(e) {
                    e.stopPropagation();
                    var input = $(this);
                    if (input.prop('checked')) {
                        documentTreeCmp.selectDocumentId(docTreeNode, input.val(), input);
                    } else {
                        documentTreeCmp.deselectDocumentId(docTreeNode, input.val(), input);
                    }
                });

                // Make the entire document row clickable
                docTreeNode.on('click', 'tr[data-id]:not(.disabled)', function(e) {
                    var input = $(this).find('input[name="doc_id"]');
                    documentTreeCmp.toggleDocumentId(docTreeNode, input.val(), input);
                });
            } else {
                docTreeNode.on('click', 'tr[data-id]:not(.disabled)', function(e) {
                    var input = $(this).find('input[name="doc_id"]');
                    documentTreeCmp.selectDocumentId(docTreeNode, input.val(), input);
                });
            }
        },

        getInputForDocumentId: function(docTreeNode, documentId) {
            return docTreeNode.find('input[name="doc_id"][value="'+documentId+'"]');
        },

        toggleDocumentId: function(docTreeNode, documentId, input) {
            documentId = parseInt(documentId, 10);
            if (!input) {
                input = documentTreeCmp.getInputForDocumentId(docTreeNode, documentId);
            }
            if (input.prop('checked')) {
                documentTreeCmp.deselectDocumentId(docTreeNode, documentId, input);
            } else {
                documentTreeCmp.selectDocumentId(docTreeNode, documentId, input);
            }
        },

        selectDocumentId: function(docTreeNode, documentId, input) {
            documentId = parseInt(documentId, 10);
            if (!input) {
                input = documentTreeCmp.getInputForDocumentId(docTreeNode, documentId);
            }

            var selectedDocuments = [];
            if (documentTreeCmp.canSelectMultiple(docTreeNode)) {
                selectedDocuments = documentTreeCmp.getSelectedDocuments(docTreeNode);
            } else {
                docTreeNode.find('tr.info').removeClass('info');
                docTreeNode.find('input[name="doc_info"]').prop('checked', false);
            }

            input.closest('tr').addClass('info');
            input.prop('checked', true);

            if (selectedDocuments.indexOf(documentId) == -1) {
                selectedDocuments.push(documentId);
            }

            docTreeNode.trigger('jsq:documentSelect', documentId);
            documentTreeCmp.updateSelectedDocuments(docTreeNode, selectedDocuments);
        },

        deselectDocumentId: function(docTreeNode, documentId, input) {
            documentId = parseInt(documentId, 10);
            if (!input) {
                input = documentTreeCmp.getInputForDocumentId(docTreeNode, documentId);
            }

            var selectedDocuments = [];
            if (documentTreeCmp.canSelectMultiple(docTreeNode)) {
                selectedDocuments = documentTreeCmp.getSelectedDocuments(docTreeNode);
                var idx = selectedDocuments.indexOf(documentId);
                if (idx != -1) {
                    selectedDocuments.splice(idx, 1)
                }
            }

            input.closest('tr').removeClass('info');
            input.prop('checked', false);

            docTreeNode.trigger('jsq:documentDeselect', documentId);
            documentTreeCmp.updateSelectedDocuments(docTreeNode, selectedDocuments);
        },

        updateSelectedDocuments: function(docTreeNode, selectedDocuments) {
            documentTreeCmp._setSelectedDocuments(docTreeNode, selectedDocuments);
            documentTreeCmp._updateCategorySelectedCounts(docTreeNode);
        },

        _updateCategorySelectedCounts: function(docTreeNode) {
            if (docTreeNode.length == 0) {
                return;
            }
            var categoryList = docTreeNode.find('.categories > table');
            var selectedDocuments = documentTreeCmp.getSelectedDocuments(docTreeNode);
            var publicDocuments = documentTreeCmp.getPublicDocuments(docTreeNode);
            var categoryIdsByDocument = docTreeNode.data('categories');

            // Get the selected document counts by category
            var selectedDocumentsByCategory = {}
            $.each([selectedDocuments, publicDocuments], function() {
                $.each(this, function(idx, docId) {
                    var categoryId = categoryIdsByDocument[docId];
                    if (Object.prototype.hasOwnProperty.call(selectedDocumentsByCategory, categoryId)) {
                        selectedDocumentsByCategory[categoryId]++;
                    } else {
                        selectedDocumentsByCategory[categoryId] = 1;
                    }
                });
            });

            // Update each category item with the count
            categoryList.find('tr').each(function(e) {
                var categoryId = $(this).data('category-id');
                var documentCount = $(this).data('count');
                var selectedCount = 0;
                if (Object.prototype.hasOwnProperty.call(selectedDocumentsByCategory, categoryId)) {
                    selectedCount = selectedDocumentsByCategory[categoryId];
                }

                if (documentTreeCmp.canSelectMultiple(docTreeNode)) {
                    if (selectedCount === documentCount) {
                        $(this).find('.selected-count').text('All ' + documentCount + ' selected');
                    } else {
                        $(this).find('.selected-count').text(selectedCount + ' of ' + documentCount + ' selected');
                    }
                } else {
                    $(this).find('.selected-count').text(selectedCount > 0 ? 'Selected' : '');
                }
            });
        },

        initializeDocumentSelections: function(docTreeNode) {
            var publicDocuments = documentTreeCmp.getPublicDocuments(docTreeNode);
            $(publicDocuments).each(function(idx, documentId) {
                $('#checkbox_'+documentId).prop('checked', true)
                                          .prop('disabled', true)
                                          .closest('tr')
                                          .addClass('info')
                                          .addClass('disabled');
            });

            var selectedDocuments = documentTreeCmp.getSelectedDocuments(docTreeNode);
            $(selectedDocuments).each(function(idx, documentId) {
                $('#checkbox_'+documentId).prop('checked', true)
                                          .closest('tr')
                                          .addClass('info');
            });
        },

        _getTreeContainer: function(docTreeNode) {
            return docTreeNode.closest('.document-tree-container');
        },

        getSelectedDocuments: function(docTreeNode) {
            return documentTreeCmp._getTreeContainer(docTreeNode).data('selected-documents');
        },

        _setSelectedDocuments: function(docTreeNode, selectedDocuments) {
            documentTreeCmp._getTreeContainer(docTreeNode).data('selected-documents', selectedDocuments);
        },

        getPublicDocuments: function(docTreeNode) {
            return documentTreeCmp._getTreeContainer(docTreeNode).data('public-documents');
        },
    };

    return documentTreeCmp;
});


